import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { Input, SubmitButton, SubTab, SubInput } from "../Form/Form";
import { createSlug } from "../../util/fn";

const Edit = (props) => {
  const { id } = props.match.params;
  const brandId = window.location.href.split("/")[4];

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm();

  const history = useHistory();

  const { languages } = useSelector((state) => state.setting);

  const { response, request } = useRequest();
  const { response: responseFetchSeeker, request: requestFetchSeeker } =
    useRequest();

  useEffect(() => {
    if (id) {
      requestFetchSeeker("GET", `brand-model/${id}`);
      document.title = `Edit Model - Easyspare`;
    }
  }, [id]);
  useEffect(() => {
    if (responseFetchSeeker?.brandModels) {
      const positionDetails = responseFetchSeeker.brandModels.langData;
      console.log("positionDetails", positionDetails)

      for (let i = 0; i < positionDetails.length; i++) {
        const code = positionDetails[i].languageCode;
        
        const name = positionDetails[i].name;
        setValue(`name-${code}`, `${name}`);
      }
    }
  }, [responseFetchSeeker]);
  useEffect(() => {
    if (response) {
      toast.success("Model updated successfully.");
      history.push(`/brands/${brandId}`);
    }
  }, [response]);

  const onSubmit = (data) => {
    const dataToSend = [];
    const checkData = {
      label: "",
      value: "",
      langData: [],
    };

    let name;

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      dataToSend.push({
        languageCode: code,
        name: data["name-" + code] ?? "",
        slug: data["slug-" + code] ?? "",
      });

      if (languages[i].default) {
        name = data["name-" + code];
        checkData.label = name;
        checkData.value = name;
      }

      checkData.langData.push({
        languageCode: code,
        value: data["name-" + code] ?? "",
        slug: data["slug-" + code] ?? "",
      });
    }

    request("PUT", "brand-model", {
      name,
      id,
      subData: dataToSend,
    });
  };

  return (
    <div className={` d-flex flex-column flex-column-fluid`} id="kt_content">
      <Breadcrumb
        title="Edit Model"
        links={[
          { to: "/", name: "Dashboard" },
          { to: `/brands/${brandId}`, name: "Back To Models" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
            <div class="card-header">
              <h3 class="card-title">Edit Model</h3>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                  tabName={`language_${index}`}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>

                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <SubInput
                                key={index}
                                index={index}
                                errors={errors}
                                register={register}
                                required={lang.required}
                                control={control}
                                code={lang.code}
                                tabName={`language_${index}`}
                                InputFields={[
                                  [
                                    {
                                      Component: Input,
                                      label: "Name",
                                      type: "text",
                                      name: "name",
                                      isRequired: true,
                                      colClass: " ",
                                      registerFields: {
                                        onBlur: (e) => {
                                          setValue(
                                            `slug-${lang.code}`,
                                            createSlug(e.target.value)
                                          );
                                        },
                                      },
                                    },
                                  ],
                                ]}
                              />
                            ))}
                        </div>
                      </div>
                    </div>

                    <div className="row"></div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Update"
                      pxClass="px-10"
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
